import { LeadsCountByTypeQuery, PageQuery } from "@/model";
import { post, get } from "@/utils/requestKong";

export const mainApi = {
  // 分页查询索赔审核
  getPageListApi: (data: PageQuery) => {
    return post({
      url: "/leadsRecord/getPageList",
      data,
    });
  },
  // 线索计数统计——主页
  leadsCountByTypeApi: () => {
    return post({
      url: "/leadsRecord/leadsCountByType",
    });
  },
  // 线索详情页统计——详情页饼图
  obtainLeadsInfoCountApi: (data: LeadsCountByTypeQuery) => {
    return post({
      url: "/leadsRecord/obtainLeadsInfoCount",
      data,
    });
  },
};

export const commonApi = {
  // 查询大区列表
  queryRegionListApi: () => {
    return post({
      url: "/leadsRecord/queryRegionList",
    });
  },

  // 查询小区列表
  queryFmcListApi: (regionCode: string) => {
    return post({
      url: "/leadsRecord/queryFmcList",
      data: {
        regionCode,
      },
    });
  },
};
